module.exports = __webpack_public_path__ + "static/media/hn.69d203cc.svg";